import React from 'react';

export default function NoSampleLabel(): JSX.Element {
  return <span className="u-faded">No sample</span>;
}
